import { Action } from "redux";
import GeoCalculationItem from "../../dto/GeoCalculationItem";

export const GEOCALC_LIST_LOADED = "GEOCALC_LIST_LOADED";

export interface LoadGeoCalculationsAction extends Action {
    data: GeoCalculationItem[];
}

export const loadGeoCalculationsAction = (data: GeoCalculationItem[]): LoadGeoCalculationsAction => {
    return {
        type: GEOCALC_LIST_LOADED,
        data: data,
    };
};
